import { UAParser } from 'ua-parser-js';

/**
 * A utility class to detect bots based on their User-Agent string.
 */
export class BotDetector {
  private static botPatterns: RegExp[] = [
    /bot/i,
    /spider/i,
    /crawler/i,
    /curl/i,
    /wget/i,
    /python-requests/i,
    /headless/i,
    /googlebot/i,
    /bingbot/i,
    /yandexbot/i,
    /duckduckbot/i,
    /baiduspider/i,
    /slurp/i,
  ];

  /**
   * Checks if a User-Agent string likely belongs to a bot.
   * @param userAgent The User-Agent string to check.
   * @returns True if the User-Agent is suspected to be a bot, false otherwise.
   */
  static isBot(userAgent: string | null | undefined): boolean {
    if (!userAgent || userAgent.length < 10) {
      return true; // Suspiciously short or empty User-Agent
    }
    return this.botPatterns.some(pattern => pattern.test(userAgent));
  }

  /**
   * Performs a more detailed analysis of the User-Agent string.
   * @param userAgent The User-Agent string to analyze.
   * @returns An object containing the parsed User-Agent details and a suspicion flag.
   */
  static analyzeUserAgent(userAgent: string) {
    const result = UAParser(userAgent);
    const isSuspicious = this.isBot(userAgent) || !result.browser.name;

    return {
      ...result,
      isSuspicious,
    };
  }
}
